import { defineStore } from "pinia";
import { computed, onMounted, onUnmounted, ref } from "vue";
import moment from "moment-timezone";

export const useTimeControlsStore = new defineStore('TimeControls', () => {

    // State
    const timeDynamic = ref(moment().tz("Europe/London"))
    const activeOfficeTimezone = ref("Europe/London")
    const interval = ref(null)

    // Actions
    function updateTimeDynamic(timezone = "Europe/London") {
        activeOfficeTimezone.value = timezone
        timeDynamic.value = moment().tz(timezone)
    }

    function timeInTimezone(timezone = "Europe/London") {
        return moment().tz(timezone)
    }

    onMounted(() => {
        interval.value = setInterval(() => {
            timeDynamic.value = moment().tz(activeOfficeTimezone.value)
        }, 30000);
    })

    onUnmounted(() => {
        clearInterval(interval.value)
    })

    return {
        timeDynamic,
        updateTimeDynamic,
        timeInTimezone
    }
});
